import React from 'react';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons';

import logoWhite from '../../assets/LOGOwhite.png';
import './NavbarBottom.css';

// Sitewide footer. Brand block + three labeled link groups + a divided bottom
// bar. Social URLs aren't live yet — '#' placeholders with aria-labels so
// they're easy to fill in later.
const NavbarBottom = () => {
	const year = new Date().getFullYear();

	return (
		<footer className='site-footer'>
			<div className='site-footer__strip' aria-hidden='true' />

			<div className='site-footer__inner'>
				{/* Brand block */}
				<div className='site-footer__brand'>
					<img
						src={logoWhite}
						alt='Color Your Voice'
						className='site-footer__logo'
					/>
					<p className='site-footer__tagline'>
						A creative harbor where confidence and artistry grow.
					</p>
					<div className='site-footer__socials'>
						{/* Placeholder hrefs — swap '#' for the real profile URLs when live. */}
						{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
						<a
							href='#'
							className='site-footer__social'
							aria-label='Color Your Voice on Instagram'>
							<FontAwesomeIcon icon={faInstagram} />
						</a>
						{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
						<a
							href='#'
							className='site-footer__social'
							aria-label='Color Your Voice on TikTok'>
							<FontAwesomeIcon icon={faTiktok} />
						</a>
					</div>
				</div>

				{/* Explore */}
				<nav className='site-footer__col' aria-label='Explore'>
					<p className='site-footer__col-label'>Explore</p>
					<ul className='site-footer__links'>
						{/* "Summer 2026" and "Workshops" both pointed at /summer and were
						    removed 2026-08-08 for the fall push. The footer renders on
						    EVERY page, so these two were the last inbound links to /summer
						    left on the site after the header nav entry and the sitemap
						    entry came out — leaving them would have kept summer one click
						    from every ad landing. The route itself is still live and
						    reachable by URL on purpose (see App.js). Restore both here
						    when the seasonal nav flag goes back on next spring. */}
						<li>
							<Link className='site-footer__link' to='/lessons'>
								Private lessons
							</Link>
						</li>
						<li>
							<Link className='site-footer__link' to='/faq'>
								FAQ
							</Link>
						</li>
					</ul>
				</nav>

				{/* Studio */}
				<nav className='site-footer__col' aria-label='Studio'>
					<p className='site-footer__col-label'>Studio</p>
					<ul className='site-footer__links'>
						<li>
							<Link className='site-footer__link' to='/faculty'>
								Our faculty
							</Link>
						</li>
						<li>
							<Link className='site-footer__link' to='/policies'>
								Policies
							</Link>
						</li>
						<li>
							<Link className='site-footer__link' to='/privacy'>
								Privacy Policy
							</Link>
						</li>
						<li>
							<Link className='site-footer__link' to='/contact'>
								Contact
							</Link>
						</li>
					</ul>
				</nav>

				{/* Visit & call */}
				<div className='site-footer__col'>
					<p className='site-footer__col-label'>Visit &amp; call</p>
					<ul className='site-footer__contact'>
						<li>
							<FontAwesomeIcon
								icon={faPhone}
								className='site-footer__contact-icon'
							/>
							<a href='tel:9522830560'>(952) 283-0560</a>
						</li>
						<li>
							<FontAwesomeIcon
								icon={faLocationDot}
								className='site-footer__contact-icon'
							/>
							Lakeville, MN
						</li>
						<li>
							<FontAwesomeIcon
								icon={faLocationDot}
								className='site-footer__contact-icon'
							/>
							Burnsville, MN
						</li>
					</ul>
				</div>
			</div>

			{/* Bottom bar */}
			<div className='site-footer__bar'>
				<p className='site-footer__fine'>
					&copy; {year} Color Your Voice, LLC &middot; site by{' '}
					<a
						href='https://anthonyapps.com/'
						target='_blank'
						rel='noreferrer'>
						anthonyapps.com
					</a>
				</p>
				<p className='site-footer__secondary'>
					Helping young artists find their voice.
				</p>
			</div>
		</footer>
	);
};

export default NavbarBottom;
